import {POST_CANDIDATES_INTEREST_STATUS,POST_CANDIDATES_INTEREST_STATUS_SUCCESS,POST_CANDIDATES_INTEREST_STATUS_FAILED} from "./actionTypes"
    //submit document
    export const postCandidateInterestStatus = (json)=>{
        return {
            type: POST_CANDIDATES_INTEREST_STATUS,
            payload: {json}
        }
    } 
    
    export const postCandidateInterestStatusSuccess = (data)=>{
        return {
            type: POST_CANDIDATES_INTEREST_STATUS_SUCCESS,
            payload: {data}
        }
    } 
    
    export const postCandidateInterestStatusFail = (message)=>{
        return {
            type:POST_CANDIDATES_INTEREST_STATUS_FAILED,
            payload: {message}
        }
    } 
    
    